// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'

export class MainSidebar extends Component {
    constructor(props) {
        super(props)

        this.logout = this.logout.bind(this)
        this.getTopPanelItems = this.getTopPanelItems.bind(this)
    }

    logout(e) {
        window.sessionStorage.clear()
        this.props.logout(false, 'login')
    }

    getTopPanelItems() {
        return {
            provider: [
                {
                    title: this.props.appData.company || window.sessionStorage.getItem("company") || "Organisation",
                    icon: "/assets/images/Icons/organisation_logo.png",
                    link: "/workforce"
                },
                /*{
                    title: "Dashboard",
                    icon: "/assets/images/icons/icon_dashboard_circled.png",
                    link:"/dashboard"
                },*/
                {
                    title: "Workforce",
                    icon: "/assets/images/Icons/icon_workflow_circled.png",
                    link: "/workforce"
                },
                {
                    title: "Training",
                    icon: "/assets/images/Icons/icon_content_circled.png",
                    link: "/providerContent"
                },
                {
                    title: "Settings",
                    icon: "/assets/images/Icons/icon_settings_circled.png",
                    link: "/settings"
                },
                {
                    title: "Help",
                    icon: "/assets/images/Icons/icon_help_circled.png",
                    link: "/help"
                }
            ],
            worker: [
                {
                    title: (this.props.appData.first_name + " " + this.props.appData.last_name) || "Individual",
                    icon: "/assets/images/Icons/individual_icon.png",
                    link: "/individual/trainingContent"
                },
                {
                    title: "Training",
                    icon: "/assets/images/Icons/icon_content_circled.png",
                    link: "/individual/trainingContent"
                },
                {
                    title: "Store",
                    icon: "/assets/images/Icons/icon_shop_thin.png",
                    link: "/workerStore"
                },
                {
                    title: "Settings",
                    icon: "/assets/images/Icons/icon_settings_circled.png",
                    link: "/settings"
                },
                {
                    title: "Help",
                    icon: "/assets/images/Icons/icon_help_circled.png",
                    link: "/help"
                }
            ]
        }
    }

    getBottomPanelItems() {
        return [
            {
                title: "Logout",
                icon: "/assets/images/Icons/icon_logout_circled.png",
                link: ""
            }
        ]
    }

    populateTopPanelItems(profileType) {
        let topPanelItems = this.getTopPanelItems()

        if (profileType === 'provider') {

            return topPanelItems.provider.map((item, index) => {
                let styleClasses = "panel-item"

                if (this.props.profile === index) {
                    styleClasses += " active"
                }

                if (item.title === "Enabler") {
                    return (
                        <div key={index} className={styleClasses}>
                            <div className="icon-container">
                                <img src={item.icon} alt={item.title} />
                            </div>
                            <span>
                                {item.title}
                            </span>
                        </div>
                    )
                }

                return (
                    <Link key={index} className={styleClasses} to={item.link}>
                        <div className="icon-container">
                            <img src={item.icon} alt={item.title} />
                        </div>
                        <span>
                            {item.title}
                        </span>
                    </Link>
                )
            })
        }
        else {
            return topPanelItems.worker.map((item, index) => {
                let styleClasses = "panel-item"

                if (this.props.profile === index) {
                    styleClasses += " active"
                }

                if (item.title === "Enabler") {
                    return (
                        <div key={index} className={styleClasses}>
                            <div className="icon-container">
                                <img src={item.icon} alt={item.title} />
                            </div>
                            <span>
                                {item.title}
                            </span>
                        </div>
                    )
                }

                return (
                    <Link key={index} className={styleClasses} to={item.link}>
                        <div className="icon-container">
                            <img src={item.icon} alt={item.title} />
                        </div>
                        <span>
                            {item.title}
                        </span>
                    </Link>
                )
            })
        }
    }

    populateBottomPanelItems() {
        return this.getBottomPanelItems().map((item, index) => {
            return (
                <Link key={index} className="panel-item">
                    <div className="icon-container">
                        <img src={item.icon} alt={item.title} />
                    </div>
                    <span>
                        {item.title}
                    </span>
                </Link>
            )
        })
    }

    render() {
        return (
            <div className="main-side-bar-container">
                <section className="main-side-panel">
                    <div className="top">
                        {this.populateTopPanelItems(this.props.profileType)}
                    </div>
                    <div className="bottom">
                        <Link
                            className="panel-item"
                            onClick={this.logout}
                        >
                            <div className="icon-container">
                                <img src="/assets/images/Icons/icon_logout_circled.png" alt="logout" />
                            </div>
                            <span>
                                Logout
                            </span>
                        </Link>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/mainsidebar.js